module.exports = __webpack_public_path__ + "img/venuethree-hzq-active.9fe3a7f7.png";